import { FC } from "react";
import { Outlet } from "react-router-dom";
import ContentErrorBoundary from "./content-error-boundary";

const Content: FC = () => {
  return (
    <main className="overflow-x-hidden border-l border-t border-gray-200 bg-[#F0F2F4] [grid-area:main]">
      <div className="container flex min-h-full flex-col py-6">
        <ContentErrorBoundary>
          <Outlet />
        </ContentErrorBoundary>
      </div>
    </main>
  );
};

export default Content;
